import { QueryKey, useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import {
  getNotInterestedReasons,
  NotInterestedReasonsResponse,
} from 'api/admin/listing/getNotInterestedReasons'

export const notInterestedReasonsKey = (listingId: number) =>
  ['listing-not-interested-reasons', listingId] as const

export const useNotInterestedReasonsQuery = (listingId: number) => {
  return useQuery<
    NotInterestedReasonsResponse,
    AxiosError,
    NotInterestedReasonsResponse,
    QueryKey
  >({
    queryKey: notInterestedReasonsKey(listingId),
    queryFn: () => getNotInterestedReasons(listingId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: Boolean(listingId),
  })
}
